<script>
import Chart from "chart.js";
import {getFrsContractState} from "@/utils/frs";
import TileLoader from "./TileLoader.vue";
import dayjs from "dayjs";
import store from "@/store/dashboards";

export default {
  components: {TileLoader},
  props: ["pDatas", "pLoading", "year"],
  data() {
    return {
      datas: [],
      loading: 0,
      store
    }
  },
  computed: {
    storeGlobalView() {
      return this.store.globalView;
    }
  },
  mounted() {
    if (this.pDatas) {
      this.datas = this.pDatas;
    }
    this.initData();
  },
  watch: {
    year(newVal) {
      if (newVal) {
        this.initData();
      }
    },
    storeGlobalView() {
      this.initData();
    },
    pLoading(newVal) {
      if (newVal) {
        this.loading = 1;
      } else {
        this.loading = 0;
      }
    },
    pDatas(newData) {
      this.datas = newData;
    },
    datas() {
      this.showChart();
    }
  },
  methods: {
    initData() {
      // On n'initialise pas les données si déjà reçues depuis les props par exemple ou si en train de charger à l'extérieur
      if ((this.pDatas && this.pDatas.length > 0) || this.pLoading) return;
      if (!this.year) return;

      this.loading = 1;

      getFrsContractState(this.year, this.storeGlobalView, false).then(res => {
        this.datas = res
          .map(row => ({...row, ContractStatus: this.contractStatusToCategory(row)}))
          .sort((a, b) => a.Name < b.Name ? -1 : 1);

        this.loading = 0;
      })
    },
    contractStatusToCategory(contract) { // On catégorise les contrats en fonction de leur statut
      if (contract.ContractStatus == 8) return 4
      if (!contract.Appointment) return 1
      if (dayjs().isBefore(dayjs(contract.Appointment))) return 2
      return 3;
    },
    showChart() {
      const canvas = document.getElementById("contract-chart");
      if (this.chart) this.chart.destroy();

      // Récupération des données pour afficher le graphique
      const data = this.datas.reduce((acc, row) => {
        acc[row.ContractStatus - 1] += 1;
        return acc;
      }, [0, 0, 0, 0])

      this.chart = new Chart(canvas, {
        type: 'doughnut',
        data: {
          labels: ['RDV à prendre', 'RDV pris', 'En négo', 'Terminé'],
          datasets: [
            {
              data,
              backgroundColor: ['#D32F2F', '#FFC107', '#388E3C', '#50E3C2'],
            },
          ],
        },
        options: {
          legend: {
            display: false
          },
          cutoutPercentage: 80,
          responsive: true,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                return " " + data.labels[tooltipItem.index] + " : " + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              }
            }
          },
          animation: {
            duration: 230
          }
        }
      });
    },
  }
}
</script>

<template>
  <div class="white-box summary position-relative">
    <TileLoader :loading="loading"/>
    <div>
      <h2>Suivi des contrats</h2>
    </div>
    <div>
      <div class="chart">
        <canvas id="contract-chart" width="180" height="180"></canvas>
        <span v-if="datas.length > 0" class="total">{{ datas.length }}</span>
      </div>
      <div class="d-flex align-items-center">
        <span class="contract-status-circle-1 inline"></span>
        {{ datas.filter(row => row.ContractStatus == 1).length }}
        rdv à prendre
        ({{ ((datas.filter(row => row.ContractStatus == 1).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="contract-status-circle-2 inline"></span>
        {{ datas.filter(row => row.ContractStatus == 2).length }}
        rdv pris
        ({{ ((datas.filter(row => row.ContractStatus == 2).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="contract-status-circle-3 inline"></span>
        {{ datas.filter(row => row.ContractStatus == 3).length }}
        en négo
        ({{ ((datas.filter(row => row.ContractStatus == 3).length / datas.length) * 100).toFixed(1) }}%)
      </div>
      <div class="d-flex align-items-center">
        <span class="contract-status-circle-4 inline"></span>
        {{ datas.filter(row => row.ContractStatus == 4).length }}
        terminés
        ({{ ((datas.filter(row => row.ContractStatus == 4).length / datas.length) * 100).toFixed(1) }}%)
      </div>
    </div>
  </div>
</template>

<style scoped>
.white-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.summary h2 {
  font-size: 20px;
  border-left: 3px solid #A7C13C;
  padding-left: 4px;
}

.summary .chart {
  position: relative;
}

.summary .chart .total {
  position: absolute;
  top: 50%;
  left: 50%;
  line-height: 1;
  transform: translate(-50%, -50%);
  font-size: 48px;
  font-weight: bold;
}

.contract-status-circle-1,
.contract-status-circle-2,
.contract-status-circle-3,
.contract-status-circle-4 {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin: auto;
}

.contract-status-circle-1.inline,
.contract-status-circle-2.inline,
.contract-status-circle-3.inline,
.contract-status-circle-4.inline {
  display: inline-block;
  margin: 0;
  margin-right: 12px;
  margin-bottom: 6px;
  margin-top: 6px;
}

.contract-status-circle-1 {
  background-color: #D32F2F;
}

.contract-status-circle-2 {
  background-color: #FFC107;
}

.contract-status-circle-3 {
  background-color: #388E3C;
}

.contract-status-circle-4 {
  background-color: #50E3C2;
}

.contract-status-container {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboards/ContractsChartTile.vue